import { render } from "./HeroAbout.vue?vue&type=template&id=2a83c520&scoped=true"
import script from "./HeroAbout.vue?vue&type=script&lang=js"
export * from "./HeroAbout.vue?vue&type=script&lang=js"

import "./HeroAbout.vue?vue&type=style&index=0&id=2a83c520&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kyleb\\OneDrive\\Documenten\\Tess website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a83c520"]])

export default __exports__